module.exports = __webpack_public_path__ + "static/media/errorNotification.86aa3510.svg";